<nb-card size="large" [nbSpinner]="sharedService.load">
  <nb-list *ngIf="dataSource?.length">
    <nb-list-item *ngFor="let user of dataSource" (click)="onItemClick(user)">
      <!--      <nb-user [name]="user.firstName + ' ' + user.lastName"> </nb-user>-->
      <app-avatar [user]="user"></app-avatar>
    </nb-list-item>
  </nb-list>
  <h6 *ngIf="dataSource && dataSource.length == 0">No user available.</h6>
</nb-card>
